import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoriesSection() {
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-wide text-accent-600">CATEGORIES</span>
            <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">主题分类</h2>
            <p className="mt-1 text-sm text-foreground-600">按题材浏览，快速锁定你喜欢的韩漫</p>
          </div>
          <Link
            to="/category"
            className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部分类 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
          {categories.map((c) => (
            <Link
              key={c.name}
              to={`/category?genre=${encodeURIComponent(c.name)}`}
              className="group flex flex-col items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300 md:p-5"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-white ${c.color}`}>
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <div>
                <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900 md:text-base">
                  {c.name}
                  <span className="whitespace-nowrap rounded-full bg-background-100 px-2 py-0.5 text-xs text-foreground-500">{c.count}</span>
                </p>
                <p className="mt-1 hidden text-xs leading-relaxed text-foreground-600 md:line-clamp-2">{c.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}